import { createEvent } from '@interhyp/platform-eventbus';
export const REFETCH_TOGGLES = createEvent('portal', 'REFETCH_TOGGLES');
